<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h430_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogAddEditViewForm"
        :model="dialogAddEditViewForm"
        :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="所属工业"
                  prop="industry"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.industry"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="品牌"
                  prop="brand"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.brand"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="名称"
                  prop="name"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.name"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="单位"
                  prop="unit"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.unit"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="价类"
                  prop="type"
                >
                  <el-select
                    v-if="eventType!=='view'"
                    v-model="dialogAddEditViewForm.type"
                    placeholder="请选择价类"
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in typeOptions"
                      :key="item.label"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                  <el-input
                    v-else
                    v-model="dialogAddEditViewForm.typeValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="批发价(元)"
                  prop="wholesalePrice"
                >
                  <el-input-number
                    v-model="dialogAddEditViewForm.wholesalePrice"
                    :min="0"
                    :precision="2"
                    :controls="false"
                    :disabled="eventType==='view'"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="零售价(元)"
                  prop="retailPrice"
                >
                  <el-input-number
                    v-model="dialogAddEditViewForm.retailPrice"
                    :min="0"
                    :precision="2"
                    :controls="false"
                    :disabled="eventType==='view'"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="modal-box">
          <h3 class="modal-title">
            备注信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item prop="remark">
                  <el-input
                    v-model="dialogAddEditViewForm.remark"
                    type="textarea"
                    placeholder="备注"
                    style="margin-top:10px;"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// API
import { saveTobaccoInfoApi, viewTobaccoInfoApi } from '@/api/v2/tobaccoInfo'

export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        industry: [{ required: true, message: '请输入所属工业', trigger: 'blur' }],
        brand: [{ required: true, message: '请输入品牌', trigger: 'blur' }],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        unit: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        wholesalePrice: [{ required: true, message: '请输入批发价', trigger: 'blur' }],
        retailPrice: [{ required: true, message: '请输入零售价', trigger: 'blur' }],
        type: [{ required: true, message: '请选择价类', trigger: 'change' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      },
      typeOptions: [{ label: '无价类', data: 0 }, { label: '一类烟', data: 1 }, { label: '二类烟', data: 2 }, { label: '三类烟', data: 3 }, { label: '四类烟', data: 4 }, { label: '五类烟', data: 5 }]
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;
        _this.dialogAddEditViewForm = {
          industry: '',
          brand: '',
          name: '',
          unit: '',
          type: 0,
          typeValue: '',
          wholesalePrice: '0',
          retailPrice: '0',
          remark: ''
        }
        if (_this.eventType !== 'add') {
          _this.loadTobaccoData()
        }

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    loadTobaccoData () {
      let _this = this;
      viewTobaccoInfoApi({ id: _this.dataId }).then((response) => {
        const { data } = response
        for (let key in _this.dialogAddEditViewForm) {
          _this.dialogAddEditViewForm[key] = data[key]
        }
        _this.dialogAddEditViewForm.id = data.id
      })
    },
    modalClose () {
      // 直接修改父组件的属性
      this.$emit('update:dialogVisible', false)
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 计算合计
    computedMathRow (val, obj, name) {
      this.limitPositiveNumber(val, obj, name)
      this.setNumberZero(obj, name)
    },
    // 新增|修改保存
    handleSave () {
      let _this = this;
      _this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          _this.$confirm((_this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '卷烟商品信息', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true })
            .then(async () => {
              saveTobaccoInfoApi(_this.dialogAddEditViewForm).then(() => {
                _this.$message({ message: '保存成功', type: 'success' })
                _this.$emit('reloadData')
                _this.modalClose()
              }).catch(() => { })
            })
            .catch(() => { })
        }
      })
    },
  }
}
</script>
<style lang="scss"  scoped>
</style>
